import React from 'react'
import Carrousel from './Carrousel';
import PicCont from './PicCont';
import { helper } from '../utilities/helper';
import Button from './Button';
import AudioAction from './design-system/audio/AudioAction';
import EventShowcase from './design-system/marketing/EventShowcase';
import MarketingIsland from './design-system/marketing/MarketingIsland';
const PastEvents = ({total_events, newsletterevents, filter, _orlando, ui, homepage, heading, description, eyebrow, sectionId}) => {
  let orlando = Boolean(_orlando)

  if (ui === 'v2') {
    return <MarketingIsland>
      <EventShowcase
        actionLabel='View Entire Portfolio'
        description={description || (orlando
          ? 'Our Orlando team supports conferences, live events, and productions across Central Florida.'
          : 'Every month, we service more than 150 conferences and events, from small local meetings to large international ones.')}
        events={newsletterevents}
        eyebrow={eyebrow === undefined ? (homepage ? null : 'Recent production work') : eyebrow}
        filter={filter}
        heading={heading || 'Recent Events'}
        motionProfile={homepage ? 'homepage' : 'static'}
        sectionId={sectionId || 'recent-events'}
        totalEvents={total_events}
      />
    </MarketingIsland>
  }


  return <section className='pastEvents'>
  <div className='upperBold'>Recent Events</div>
  <strong className='totalEvents'>{total_events} events serviced in {new Date().getFullYear()}</strong>
  {orlando ?
   <p>We expanded to Orlando to be able to bring to all Florida the Top Rated service Miami Sound Rental is known for.</p>
:
<p>Every month, we service more than 150 conferences and events, from small local meetings to large international ones.</p>
}
<div className="buttons">
  {ui === 'v2'
    ? <AudioAction mode='primary' href='/portfolio'>View Entire Portfolio</AudioAction>
    : <Button  href={`/portfolio`} className={'btn-3  highLight'}>View Entire Portfolio</Button>}
</div>

  <Carrousel ui={ui} size={3} array={newsletterevents?.filter(n => !filter || filter.includes(n.category)).sort((a,b) => new Date(b.date).getTime() - new Date(a.date).getTime()).map(e => ui === 'v2' ? <AudioAction mode='card' href={`/portfolio/${helper.makeUrl(e.title)}`} className='nEvent' key={e._id} wrapContent={false}>
      <PicCont height={1200} width={1600} picture={e.pictures[0]} />
      <strong className="eventName">{e.title}</strong>
      <span className="date">{new Date(e.date).toDateString()}</span>
  </AudioAction> : <a href={`/portfolio/${helper.makeUrl(e.title)}`} className='nEvent' key={e._id}>
      <PicCont height={1200} width={1600} picture={e.pictures[0]} />
      <strong className="eventName">{e.title}</strong>
      <span className="date">{new Date(e.date).toDateString()}</span>
  </a>)} />
</section>


}

export default PastEvents
